import React, { Component } from 'react'
import { Marker, Popup } from 'react-leaflet';
import { withRouter } from 'react-router-dom';
import { LocationAIcon, LocationBIcon } from '../icons/Icons';

import "../styles/Marker.css";

class StationMarker extends Component {
    render() {
        return (
            this.props.loc.coordinates ? (
                <Marker
                    position={[this.props.loc.coordinates.latitude, this.props.loc.coordinates.longitude]}
                    icon={
                        this.props.locationIcon
                    }
                >
                    <Popup className='marker'>
                        <h5>{this.props.loc.name}</h5>
                        {this.props.loc.additionalInfo ? (
                            <p dangerouslySetInnerHTML={{ __html: this.props.loc.additionalInfo }}></p>
                        ) : null}
                        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '5px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}
                                onClick={() => { this.props.setOrigin({ type: "coord", name: this.props.loc.name, id: "coord:" + this.props.loc.coordinates.longitude * 1000000 + ":" + this.props.loc.coordinates.latitude * 1000000 + ":WGS84", quality: "1000", coords: { lat: this.props.loc.coordinates.latitude, long: this.props.loc.coordinates.longitude } }); this.props.history.push("/") }}
                                onTouchEnd={() => { this.props.setOrigin({ type: "coord", name: this.props.loc.name, id: "coord:" + this.props.loc.coordinates.longitude * 1000000 + ":" + this.props.loc.coordinates.latitude * 1000000 + ":WGS84", quality: "1000", coords: { lat: this.props.loc.coordinates.latitude, long: this.props.loc.coordinates.longitude } }); this.props.history.push("/") }}>
                                <p style={{ margin: '2px' }}>Von hier</p>
                                <LocationAIcon style={{ height: "40px" }} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}
                                onClick={() => { this.props.setDestination({ type: "coord", name: this.props.loc.name, id: "coord:" + this.props.loc.coordinates.longitude * 1000000 + ":" + this.props.loc.coordinates.latitude * 1000000 + ":WGS84", quality: "1000", coords: { lat: this.props.loc.coordinates.latitude, long: this.props.loc.coordinates.longitude } }); this.props.history.push("/") }}
                                onTouchEnd={() => { this.props.setDestination({ type: "coord", name: this.props.loc.name, id: "coord:" + this.props.loc.coordinates.longitude * 1000000 + ":" + this.props.loc.coordinates.latitude * 1000000 + ":WGS84", quality: "1000", coords: { lat: this.props.loc.coordinates.latitude, long: this.props.loc.coordinates.longitude } }); this.props.history.push("/") }}>
                                <p style={{ margin: '2px' }}>Hierher</p>
                                <LocationBIcon style={{ height: "40px" }} />
                            </div>
                        </div>
                    </Popup>
                </Marker>
            ) : null)
    }
}

export default withRouter(StationMarker);